import { Stack, Link } from "@mui/material"
import { Link as RouterLink, useLocation } from 'react-router-dom'

export default function PageOptions() {
	const { pathname } = useLocation();
	const OPTIONS = [
		// {name: 'Análise de Região', to: '/dashboard/analise'},
		{ name: 'Estudos de Viabilidade', to: '/dashboard/studies', include: 'dashboard' }
	];

	return (
		<Stack direction='row' alignItems='center' spacing={2}>
			{OPTIONS.map((option, index) =>
				<Link key={index} variant="subtitle2" component={RouterLink} to={option.to} sx={{ color: (theme) => pathname.includes(option.include) ? theme.palette.primary.main : theme.palette.text.primary }}>
					{option.name}
				</Link>
			)}
		</Stack>
	)
}